(function ($) {
  'use strict';

  /**
   * GA Click Event Tracking
   */

  // Handle basic buttons & links
  $(document).on('click', 'a[href], button', function () {
    // Skip if GA is _not_ available
    if ( typeof dataLayer === 'undefined' || ! is_gtm_loaded() ) {
      return true;
    }

    var $this = $(this);
    var $com_container = $this.closest( '[data-comname]' );

    if ( $com_container.length ) {
      var comname = $com_container.attr( 'data-comname' );
      var link_text = $this.text() || '';
      var event_args = {
        event: 'component_link_click',
        event_category: comname.trim(),
        event_action: 'click',
        event_label: link_text.trim(),
      };

      // Capture the event
      dataLayer.push( event_args );
    }
  });


  /**
   * Checks if the GTM has loaded & is available for use.
   * @returns {Boolean} True if GTM has fully loaded.
   */
  function is_gtm_loaded() {
    window.dataLayer = window.dataLayer || [];

    // Get the GTM start event data
    var gtm_start = window.dataLayer.find(function ( element ) {
      return element['gtm.start'];
    });

    // Start event has _not_ fired (No embed on page)
    if ( ! gtm_start ) {
      return false;
    // GTM did _not_ init (Ad-block, URL blocking, etc.)
    } else if ( ! gtm_start['gtm.uniqueEventId'] ) {
      return false;
    }

    // GTM is ready for use
    return true;
  }

})(jQuery);
